// @ts-check

import { MapView, Mappedin, getVenue } from "@mappedin/mappedin-js";
import { useEffect, useState } from "react";




/**
 * @param {any} props
 * @param {any[]} dependencyArray
 * 
 */
export default function useLoadMapSettings(props, dependencyArray) {

  let actions = props.actions;
  
  let mapId = props.match.params.mapId;
  // console.log('mapId ===> ', mapId);

  useEffect(() => {
    console.log('SETTINGS LOAD ===> ');
    actions.fetchMapSettings(mapId);

  }, [...dependencyArray]);


  return [

  ];
}





